
  import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry for error tracking
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "development",
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Capture 10% of all sessions for general monitoring
        // Capture 100% of sessions with errors
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance monitoring: capture 10% of transactions
    tracesSampleRate: 0.1,
    // Session Replay: capture errors only by default
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Send default PII data (IP address, etc.)
    sendDefaultPii: true,
  });
}

createRoot(document.getElementById("root")!).render(<App />);
